import { useState } from "react";
import { useIMask } from "react-imask";
import { useFormContext } from "react-hook-form";

import TextField from "./text-field";

import { validation } from "../../Utils/validations";

import { ssnMask } from "../../Utils/constants";

import { getMaskedSSN, removeControlCharacters } from "../../Utils/helpers";

export default function SSNField({ placeholder = "", required = true, ...otherProps }) {
  const [isFocused, setIsFocused] = useState(false);

  const { register, watch, getFieldState, formState } = useFormContext();

  const ssn = watch("ssn") ?? "";

  const ssnFieldProps = register("ssn", {
    required,
    validate: (ssn) => validation.SSN.isAValidSSN(ssn) || "Please enter your 9-digit Social Security Number.",
  });

  const { ref } = useIMask(
    {
      mask: ssnMask,
      eager: true,
    },
    {
      onAccept: (value) => ssnFieldProps.onChange?.({ target: { name: "ssn", value: removeControlCharacters(value) } }),
    }
  );

  const { error: ssnFieldError } = getFieldState(ssnFieldProps.name, formState);

  return (
    <TextField
      {...ssnFieldProps}
      ref={(ele) => {
        ref.current = ele;
        ssnFieldProps.ref(ele);
      }}
      value={isFocused ? ssn : getMaskedSSN(ssn)}
      onFocus={() => setIsFocused(true)}
      onBlur={(e) => {
        ssnFieldProps.onBlur({
          target: { name: "ssn", value: removeControlCharacters(e.target.value) },
        });
        setIsFocused(false);
      }}
      label="Social Security Number (SSN)"
      placeholder={placeholder}
      error={!!ssnFieldError}
      errorMessage={ssnFieldError?.message}
      {...otherProps}
    />
  );
}
